import moment from "moment";
const MAX_DAYS = 33;

(function (angular) {
  "use strict";

  angular
    .module("fleetviewApp")
    .component("complianceQueryString", {
      template: require("./compliance-querystring.component.html"),
      controller: ComplianceQueryStringController
    });

  ComplianceQueryStringController.$inject = [
    "$location",
    "$q",
    "LayoutService",
    "GroupsService",
    "$scope",
    "$state",
    "$stateParams"
  ];

  function ComplianceQueryStringController($location, $q, LayoutService, GroupsService, $scope, $state, $stateParams) {
    let vm = this;
    vm.$onInit = init;
    function init() {

      let endDate = _getEndDateFromQueryString();
      let startDate = _getStartDatefromQueryString(endDate);
      let tripIds = _getTripIdsFromQueryString();
      let vehicleIds = _getVehicleIdsFromQueryString();
      let driverIds = _getDriverIdsFromQueryString();
      let hideNoOOr = _getIncludeRoutesWithNoOORMilesFromQueryString();
      let hideQuestionable = _getNoQuestionableRoutesFromQueryString();
      let promises = [
        _getVehicleGroupIdsFromQueryString(),
        _getDriverGroupIdsFromQueryString(),
      ];

      $q.all(promises).then((queryResults) => {
        let vehicleGroupIds = queryResults[0];
        let driverGroupIds = queryResults[1];

        let ids = [];
        let groupType = "vehicle";
        let groupIds = [];

        if (vehicleGroupIds.length > 0 || vehicleIds.length > 0) {
          groupType = "vehicle";
          ids = vehicleIds;
          groupIds = vehicleGroupIds;

        } else {
          groupType = "driver";
          ids = driverIds;
          groupIds = driverGroupIds;
        }

        vm.settings = {
          startDate: startDate,
          endDate: endDate,
          idType: groupType,
          noQuestionableRoutes: hideQuestionable,
          includeRoutesWithNoOorMiles: !hideNoOOr,
          ids: ids,
          tripId: tripIds,
          groupId: groupIds
        };
        showRoutes(vm.settings);
      });
    }
    function showRoutes(settings) {
      //console.log("getting data with the following options ", vm.settings);
      $state.go($stateParams.childState, {
        settings: vm.settings,
        queryUrl: $stateParams.queryUrl
      });
      vm.startDate = vm.settings.startDate.toLocaleDateString();
      vm.endDate = vm.settings.endDate.toLocaleDateString();
    }

    function _getVehicleGroupIdsFromQueryString() {
      let groupNames = _getArrayFromQueryString("vehicleGroupName");
      if (groupNames.length === 0) {
        return $q.when([]);
      }

      let groupNamesObj = {};
      groupNames.forEach(groupName => groupNamesObj[groupName.toUpperCase()] = -1);

      return GroupsService
        .getVehicleGroups()
        .then(groups => {
          let groupIds = [];

          for (let i = 0; i < groups.length; i++) {
            if (groups[i].name != null && groupNamesObj[groups[i].name.toUpperCase()] === -1) {
              groupIds.push(groups[i].id);
            }
          }

          return groupIds;
        });
    }

    function _getDriverGroupIdsFromQueryString() {
      let groupNames = _getArrayFromQueryString("driverGroupName");
      if (groupNames.length === 0) return $q.when([]);

      let groupNamesObj = {};
      groupNames.forEach(groupName => groupNamesObj[groupName.toUpperCase()] = -1);

      return GroupsService
        .getDriverGroups()
        .then(groups => {
          let groupIds = [];

          for (let i = 0; i < groups.length; i++) {
            if (groups[i].name != null && groupNamesObj[groups[i].name.toUpperCase()] === -1) {
              groupIds.push(groups[i].id);
            }
          }

          return groupIds;
        });
    }

    function _getTripIdsFromQueryString() {
      return _getArrayFromQueryString("tripId");
    }

    function _getVehicleIdsFromQueryString() {
      return _getArrayFromQueryString("vehicleId")
        .filter(c => _isNumber(c))
        .map(c => parseInt(c));
    }

    function _getDriverIdsFromQueryString() {
      return _getArrayFromQueryString("driverId")
        .filter(c => _isNumber(c))
        .map(c => parseInt(c));
    }

    function _getIncludeRoutesWithNoOORMilesFromQueryString() {
      if (typeof $location.search().hideNoOOR === "string") {
        return $location.search().hideNoOOR.toUpperCase() === "TRUE";
      }

      return false;
    }

    function _getNoQuestionableRoutesFromQueryString() {
      if (typeof $location.search().hideQuestionable === "string") {
        return $location.search().hideQuestionable.toUpperCase() === "TRUE";
      }

      return true;
    }

    /**
     * Returns the initial end date for the screen.
     *
     * @returns a Date javascript object representing the end date
     */
    function _getEndDateFromQueryString() {
      let endDate = moment($location.search().endDate, moment.ISO_8601);

      // if there is no valid end date passed in, take todays date
      if (!endDate.isValid()) {
        return moment().endOf("day")
          .toDate();
      }

      return endDate.toDate();
    }

    /**
     * Returns the initial start date for the screen.
     * If the "startDate" query string parameter exists it uses this in the calculation
     *
     * @param {any} endDateJS Date Javascript object representing the end date
     * @returns a Date Javascript object representing the start date
     */
    function _getStartDatefromQueryString(endDateJS) {
      let endDate = moment(endDateJS);

      let startDate = moment($location.search().startDate, moment.ISO_8601);

      // if date is not valid, return one month  before the end date.
      if (!startDate.isValid()) {
        return endDate.subtract(MAX_DAYS, "days")
          .startOf("day")
          .toDate();
      }

      // if the start date is after the end date, send the end date back
      if (startDate.isAfter(endDate)) {
        return endDate.startOf("day")
          .toDate();
      }

      // it is a valid start date, return it back.
      return startDate.toDate();
    }

    function _getArrayFromQueryString(param) {
      let search = $location.search();
      let value = search[param];
      if (typeof value !== "string") {
        return [];
      }

      return decodeURIComponent(value)
        .split(",")
        .map(c => c.trim())
        .filter(c => c !== "")
        .unique();
    }

    // TODO: put into common file
    function _isValidDate(str) {
      let date = new Date(str);

      if (Object.prototype.toString.call(date) !== "[object Date]") return false;

      if (isNaN(date.getTime())) return false;

      return true;
    }

    // TODO: put into common file
    function _isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  }
})(window.angular);



// WEBPACK FOOTER //
// ./app/compliance/compliance-querystring.component.js